"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = exports.DEFAULT_LOCATION_RADIUS_KM = void 0;
const legacy_config_1 = require("@daytrip/legacy-config");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const graphql_1 = require("../graphql");
const orm_1 = require("../orm");
const transformNameToMachineName_1 = require("../transformers/transformNameToMachineName");
const transformToDate_1 = require("../transformers/transformToDate");
const getPrimaryLocationImage_1 = require("../utils/getPrimaryLocationImage");
const IsTrimmed_1 = require("../validators/IsTrimmed");
const LocalizedField_1 = require("./LocalizedField");
const LocationImage_1 = require("./LocationImage");
const LocationPosition_1 = require("./LocationPosition");
const Position_1 = require("./Position");
const Season_1 = require("./Season");
exports.DEFAULT_LOCATION_RADIUS_KM = 15;
let Location = class Location extends orm_1.CDBaseEntity {
    constructor() {
        super(...arguments);
        this._id = (0, uuid_1.v4)();
        // Text Fields
        this.name = "";
        // Localized Text Fields
        this.nameLocalized = new LocalizedField_1.LocalizedField();
        this.titleLocalized = new LocalizedField_1.LocalizedField();
        this.descriptionLocalized = new LocalizedField_1.LocalizedField();
        this.perexLocalized = new LocalizedField_1.LocalizedField();
        this.isGenerated = false; // the location was generated automatically and not updated since
        this.isVisited = false; // the location has been visited by a customer at least once
        this.isReviewed = false; // the location was manually reviewed by a content manager
        this.isReady = false;
        this.isLive = false;
        this.isDestination = false;
        this.isLocation = false;
        this.isAirport = false;
        this.isHarbor = false;
        this.isSuggested = false;
        this.isApiOnly = false; // the location can only be used by API requests, it won't appear on the website
        this.localNames = [];
        this.machineName = "";
        this.otherNames = [];
        this.airportCodes = [];
        this.score = 0;
        this.defaultDuration = 60;
        this.note = "";
        this.address = "";
        this.timezone = "";
        this.entrancePositions = [];
        this.parkingPositions = [];
        this.entrancePrice = 0;
        this.entranceFee = 0;
        this.parkingPrice = 0;
        this.parkingFee = 0;
        this.additionalPrice = 0;
        this.additionalFee = 0;
        this.seasons = [];
        this.images = [];
        this.tagIds = [];
        this.createdAt = new Date();
        this.ordersCount = 0;
    }
    // don't know why positions in locationModel stored without id and what will be broken if this.position._id will exists
    get positionWithId() {
        return {
            latitude: this.position.latitude,
            longitude: this.position.longitude,
            _id: this._id,
        };
    }
};
exports.Location = Location;
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "_id", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.Length)(1, 64),
    (0, class_validator_1.IsString)(),
    (0, IsTrimmed_1.IsTrimmed)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "name", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((0, orm_1.getTransformFromLocalizedField)("titleLocalized")),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "title", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((0, orm_1.getTransformFromLocalizedField)("perexLocalized")),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "perex", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((0, orm_1.getTransformFromLocalizedField)("descriptionLocalized")),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "description", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateIf)((location) => (location.isLive || location.isReady) && (location.isLocation || location.isDestination)),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], Location.prototype, "nameLocalized", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateIf)((location) => (location.isLive || location.isReady) && location.isLocation),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], Location.prototype, "titleLocalized", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateIf)((location) => (location.isLive || location.isReady) && location.isLocation),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], Location.prototype, "descriptionLocalized", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateIf)((location) => (location.isLive || location.isReady) && location.isLocation),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], Location.prototype, "perexLocalized", void 0);
__decorate([
    (0, graphql_1.GField)(),
    __metadata("design:type", String)
], Location.prototype, "image", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isGenerated", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isVisited", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isReviewed", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isReady", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isLive", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isDestination", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isLocation", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isAirport", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isHarbor", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isSuggested", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Location.prototype, "isApiOnly", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], Location.prototype, "localNames", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.Length)(1, 64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => (value ? (0, transformNameToMachineName_1.transformNameToMachineName)(value) : "")),
    __metadata("design:type", String)
], Location.prototype, "machineName", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], Location.prototype, "otherNames", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], Location.prototype, "airportCodes", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Location.prototype, "score", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Location.prototype, "defaultDuration", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "note", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "address", void 0);
__decorate([
    (0, graphql_1.GField)(() => LocationPosition_1.LocationPosition),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => LocationPosition_1.LocationPosition),
    __metadata("design:type", LocationPosition_1.LocationPosition)
], Location.prototype, "position", void 0);
__decorate([
    (0, graphql_1.GField)(() => String),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "timezone", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Position_1.Position),
    __metadata("design:type", Array)
], Location.prototype, "entrancePositions", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Position_1.Position),
    __metadata("design:type", Array)
], Location.prototype, "parkingPositions", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "countryId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "countryName", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "regionId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Location.prototype, "entrancePrice", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Location.prototype, "entranceFee", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Location.prototype, "parkingPrice", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Location.prototype, "parkingFee", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Location.prototype, "additionalPrice", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Location.prototype, "additionalFee", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Season_1.Season),
    __metadata("design:type", Array)
], Location.prototype, "seasons", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "websiteUrl", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.ValidateIf)((location) => location.isLive || location.isReady),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => LocationImage_1.LocationImage),
    __metadata("design:type", Array)
], Location.prototype, "images", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((_, obj) => obj.images == null || obj.images.length === 0
        ? ""
        : (0, getPrimaryLocationImage_1.getPrimaryLocationImage)(obj.images)),
    __metadata("design:type", String)
], Location.prototype, "imageUrl", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], Location.prototype, "tagIds", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "createdBy", void 0);
__decorate([
    (0, orm_1.CDCreateDateColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Location.prototype, "createdAt", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0.01),
    (0, class_validator_1.Max)(100),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], Location.prototype, "radiusKm", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Location.prototype, "ordersCount", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "ticketsUrl", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateIf)((location) => location.countryId === legacy_config_1.US_COUNTRY_ID),
    (0, class_validator_1.IsDefined)({ always: true }),
    (0, class_validator_1.IsString)({ always: true }),
    (0, class_validator_1.IsNotEmpty)({ always: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "state", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ValidateIf)((location) => location.countryId === legacy_config_1.US_COUNTRY_ID),
    (0, class_validator_1.IsDefined)({ always: true }),
    (0, class_validator_1.IsString)({ always: true }),
    (0, class_validator_1.IsNotEmpty)({ always: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Location.prototype, "stateCode", void 0);
exports.Location = Location = __decorate([
    (0, orm_1.CDEntity)("locations"),
    (0, graphql_1.GObjectType)("Location"),
    (0, graphql_1.GInputType)("LocationInput")
], Location);
//# sourceMappingURL=Location.js.map